import { render, staticRenderFns } from "./taxForm.vue?vue&type=template&id=49858568&scoped=true"
import script from "./taxForm.vue?vue&type=script&lang=js"
export * from "./taxForm.vue?vue&type=script&lang=js"
import style0 from "./taxForm.vue?vue&type=style&index=0&id=49858568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49858568",
  null
  
)

export default component.exports